var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconEmailReceived(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512pt",
    viewBox: "-30 0 512 512.00202",
    width: "512pt",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#445ea0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3216,
    stopColor: "#415a9b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6926,
    stopColor: "#364d8d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2a3d7c"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 225.65222421,
    x2: 225.65222421,
    xlinkHref: "#a",
    y1: 485.0637698646,
    y2: 509.734916814
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 338.470257687,
    x2: 193.5995361774,
    y1: 501.5422706364,
    y2: 386.1821618928
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2a3d7c",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3949,
    stopColor: "#273a77",
    stopOpacity: 0.396078
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8504,
    stopColor: "#1e3069",
    stopOpacity: 0.85098
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a2b63"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    x1: 99.465902337,
    x2: 491.2600591764,
    xlinkHref: "#a",
    y1: 149.6447495646,
    y2: 541.438906404
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    gradientUnits: "userSpaceOnUse",
    x1: 113.0562549888,
    x2: 462.6538609056,
    y1: 163.2351022164,
    y2: 512.8327081332
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fffcf8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#faf8f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4041,
    stopColor: "#eceef2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6353,
    stopColor: "#d5dcea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#b5c4df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a1b5d8"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    gradientUnits: "userSpaceOnUse",
    x1: 336.8276486898,
    x2: 78.3080966898,
    y1: 348.1615096086,
    y2: 47.2285936086
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a1b5d8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2632,
    stopColor: "#8ea0ba",
    stopOpacity: 0.262745
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5306,
    stopColor: "#808fa3",
    stopOpacity: 0.529412
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7822,
    stopColor: "#778595",
    stopOpacity: 0.780392
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#748290"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd00d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.332,
    stopColor: "#ffc010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9779,
    stopColor: "#ff9717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9517"
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    gradientUnits: "userSpaceOnUse",
    x1: 225.65222421,
    x2: 225.65222421,
    xlinkHref: "#g",
    y1: 108.56306421,
    y2: 297.576201192
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    gradientUnits: "userSpaceOnUse",
    x1: 225.65222421,
    x2: 225.65222421,
    xlinkHref: "#g",
    y1: 211.0777807452,
    y2: 356.0456490552
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "j"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9517",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3074,
    stopColor: "#ee8421",
    stopOpacity: 0.305882
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6784,
    stopColor: "#e07728",
    stopOpacity: 0.678431
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#db722b"
  }))), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    gradientUnits: "userSpaceOnUse",
    x1: 344.6153482254,
    x2: 236.8837879182,
    xlinkHref: "#j",
    y1: 247.1240909352,
    y2: 106.4891516946
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    gradientUnits: "userSpaceOnUse",
    x1: 227.4167211366,
    x2: 268.013076426,
    xlinkHref: "#g",
    y1: 101.5323422376,
    y2: 324.8122458372
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    gradientUnits: "userSpaceOnUse",
    x1: 282.144805374,
    x2: 165.6762940512,
    xlinkHref: "#j",
    y1: 159.6116881362,
    y2: 47.1825448134
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    gradientUnits: "userSpaceOnUse",
    x1: 220.4568900726,
    x2: 253.6396922874,
    y1: 59.8980713406,
    y2: 93.0808735554
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00e7b2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2459,
    stopColor: "#05e5b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5301,
    stopColor: "#13ddac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8322,
    stopColor: "#2ad1a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3ac9a0"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m249.789062 455.71875v-73.429688h-48.277343v73.429688c0 6.742188-4.875 12.492188-11.523438 13.589844l-64.820312 10.710937c-9.351563 1.546875-16.214844 9.636719-16.214844 19.121094v5.960937c0 3.808594 3.085937 6.898438 6.898437 6.898438h219.601563c3.808594 0 6.898437-3.089844 6.898437-6.898438v-5.960937c0-9.484375-6.863281-17.574219-16.21875-19.121094l-64.816406-10.710937c-6.648437-1.101563-11.527344-6.847656-11.527344-13.589844zm0 0",
    fill: "url(#b)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m342.351562 505.101562v-5.960937c0-9.480469-6.859374-17.570313-16.21875-19.117187l-64.816406-10.714844c-6.648437-1.097656-11.527344-6.847656-11.527344-13.585938v-73.433594h-48.277343v40.703126l89.007812 89.011718h44.933594c3.808594-.003906 6.898437-3.09375 6.898437-6.902344zm0 0",
    fill: "url(#c)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m0 411.90625v-272.148438c0-6.125 4.964844-11.085937 11.089844-11.085937h429.125c6.125 0 11.085937 4.960937 11.085937 11.085937v272.148438c0 6.121094-4.960937 11.085938-11.085937 11.085938h-429.125c-6.125 0-11.089844-4.964844-11.089844-11.085938zm0 0",
    fill: "url(#d)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m20.203125 393.953125v-236.242187c0-4.390626 3.558594-7.949219 7.945313-7.949219h395.003906c4.390625 0 7.949218 3.558593 7.949218 7.949219v236.242187c0 4.390625-3.558593 7.949219-7.949218 7.949219h-395.003906c-4.386719 0-7.945313-3.558594-7.945313-7.949219zm0 0",
    fill: "url(#e)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m431.101562 393.953125v-236.242187c0-4.390626-3.558593-7.949219-7.949218-7.949219h-374.222656v163.144531c0 3.59375 2.152343 6.679688 5.234374 8.054688l80.9375 80.941406h288.054688c4.386719 0 7.945312-3.558594 7.945312-7.949219zm0 0",
    fill: "url(#f)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m393.550781 321.730469h-335.796875c-4.875 0-8.824218-3.949219-8.824218-8.824219v-214.796875c0-4.875 3.949218-8.824219 8.824218-8.824219h335.796875c4.871094 0 8.824219 3.949219 8.824219 8.824219v214.796875c0 4.875-3.949219 8.824219-8.824219 8.824219zm0 0",
    fill: "url(#h)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m234.160156 159.203125 165.582032 159.984375c-1.59375 1.570312-3.777344 2.542969-6.191407 2.542969h-335.796875c-2.414062 0-4.601562-.972657-6.195312-2.542969l165.582031-159.984375c4.75-4.582031 12.273437-4.582031 17.019531 0zm0 0",
    fill: "url(#i)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m56.855469 89.332031c-.148438.015625-.292969.042969-.441407.066407-.140624.019531-.285156.035156-.425781.0625-.214843.042968-.421875.101562-.628906.160156-.070313.019531-.140625.035156-.207031.054687-.242188.074219-.476563.164063-.707032.257813-.03125.011718-.066406.023437-.097656.035156-.257812.109375-.507812.226562-.75.359375-.003906 0-.007812.003906-.011718.003906-.746094.402344-1.425782.90625-2.023438 1.496094l3.859375 3.730469c-.019531.023437-.046875.042968-.066406.0625l234.507812 226.109375h103.6875c4.875 0 8.824219-3.949219 8.824219-8.824219v-214.796875c0-.390625-.035156-.777344-.085938-1.152344-.039062-.007812-.074218-.015625-.117187-.019531l.101563-.097656c-.140626-.984375-.441407-1.917969-.882813-2.769532-.921875-.476562-1.933594-.800781-3.007813-.925781l1.363282-1.316406c-.597656-.589844-1.277344-1.09375-2.023438-1.496094-.003906 0-.007812-.003906-.011718-.003906-.246094-.132813-.496094-.253906-.753907-.359375-.03125-.015625-.0625-.023438-.09375-.035156-.230469-.09375-.46875-.183594-.707031-.257813-.070312-.019531-.140625-.035156-.210938-.054687-.207031-.058594-.414062-.117188-.625-.160156-.140624-.027344-.285156-.042969-.429687-.066407-.144531-.019531-.292969-.050781-.441406-.066406-.292969-.027344-.589844-.042969-.890625-.042969-.003906 0-.003906 0-.007813 0h-335.796875c-.003906 0-.003906 0-.007812 0-.300782 0-.597656.015625-.890625.046875zm0 0",
    fill: "url(#k)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m234.160156 251.808594 165.582032-159.980469c-1.59375-1.574219-3.777344-2.542969-6.191407-2.542969h-335.796875c-2.414062 0-4.601562.972656-6.195312 2.542969l165.582031 159.980469c4.75 4.585937 12.273437 4.585937 17.019531 0zm0 0",
    fill: "url(#l)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m271.507812 89.285156h-91.804687l30.964844 54.722656c1.351562 2.386719 3.136719 4.277344 5.164062 5.683594l172.039063 172.039063h5.679687c4.875 0 8.824219-3.949219 8.824219-8.824219v-92.753906zm0 0",
    fill: "url(#m)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m173.640625 78.574219 37.027344 65.433593c6.59375 11.648438 23.375 11.648438 29.96875 0l37.027343-65.433593c6.496094-11.476563-1.796874-25.695313-14.984374-25.695313h-8.542969l6.121093-43.195312c.726563-5.113282-3.242187-9.683594-8.40625-9.683594h-52.398437c-5.164063 0-9.132813 4.570312-8.40625 9.683594l6.121094 43.195312h-8.546875c-13.183594 0-21.476563 14.21875-14.980469 25.695313zm0 0",
    fill: "url(#n)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmailReceived);
export default __webpack_public_path__ + "static/media/icon-email-received.76fbded60603b32d9b6df9f390895d17.svg";
export { ForwardRef as ReactComponent };